import { createUseStyles } from "react-jss";

export const useDropdownStyles = createUseStyles({
  filterPopoverTitle: {
    "& .euiFormControlLayout": {
      maxWidth: "100%",
      width: "100%",
      height: "38px",
    },
    borderBlockEnd: ".6px solid var(--border-color)",
    "& .euiFieldSearch": {
      //borderRadius: "6px 6px 0 0",
      height: "38px",
      boxShadow: "none",
      borderBottom: ".6px solid var(--border-color)",
    },
    "& .euiFieldSearch--compressed": {
      boxShadow: "none",
    },
    "& .euiPopoverTitle": {
      padding: "0px!important",
      borderBlockEnd: ".6px solid var(--border-color)",
    },
    "& .wis-wis0e4-euiPopoverTitle-none-s": {
      borderBlockEnd: ".6px solid var(--border-color)",
      padding: "0px!important",
    },
  },
  search_input: {
    border: "none",
    borderRadius: 0,
    maxWidth: "100%",
    width: "100%",
  },
  search_input2: {
    "& .euiFormControlLayout, & .euiFormControlLayout__children, & .euiFieldSearch, & input[type='search']":
      {
        border: "none !important",
        boxShadow: "none !important",
        background: "transparent !important",
      },

    // kill pseudo-elements that EUI uses to draw borders
    "& .euiFormControlLayout::after, & .euiFormControlLayout::before, & .euiFieldSearch::after, & .euiFieldSearch::before":
      {
        display: "none !important",
        border: "none !important",
        boxShadow: "none !important",
      },
  },

  //Selectable
  optionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "8px 1px",
    width: "100%",
    boxSizing: "border-box",
    "& > *": {
      width: "100%",
    },
    "& label": {
      width: "100%",
    },
  },
  checkboxLabel: {
    display: "grid",
    gridTemplateColumns: "6.5fr 3.5fr",
    width: "100%",
  },

  hideEuiCheckmarks: {
    "& .euiSelectableListItem__iconCheck": {
      display: "none !important",
    },
    "& .euiSelectableListItem__content--selected::after": {
      display: "none !important",
    },
    "& .euiSelectableListItem__prepend": {
      display: "none !important",
    },
    "& .euiSelectableListItem__append": {
      display: "none !important",
    },
    "& .euiPopover__anchor": {
      width: "100%",
    },
  },
  overrideTruncation: {
    "& .euiSelectableListItem__text.euiSelectableListItem__text--truncate": {
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
      display: "block",
      width: "100%",
      flex: 1,
    },
    "& .euiSelectableListItem__text.euiSelectableListItem__text--truncate > div": {
      width: "100%",
      flex: 1,
    },
  },
  tagAccordionButton: {
    "& .euiAccordion__buttonContent": {
      width: "100%",
    },
    "& .euiAccordion__button": {
      padding: "0 10px",
      width: "100%",
    },
    "& .euiAccordion__triggerWrapper": {
      borderBottom: "1px solid var(--border-color)",
      paddingRight: "8px",
      "&:hover": {
        backgroundColor: "var(--hover-background)",
      },
    },
    "& .euiAccordion__children": {
      padding: 0,
    },
  },
  tagOptionRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "8px 12px 8px 22px",
    width: "100%",
    borderBottom: "1px solid var(--border-color)",
    boxSizing: "border-box",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "var(--hover-background)",
    },
    "& > *": {
      width: "100%",
    },
    "& label": {
      width: "100%",
    },
  },
});
